import { CSSResultGroup, TemplateResult, html, PropertyValues } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { SlotController } from 'src/components/controllers/slot-controller';
import componentStyles from './idb-toggle-dashboard.css.lit';

/**
 * The IDB Toggle Dashboard component
 * @element idb-toggle-dashboard
 * @slot - The default slot to render a `toggle group` elements in.
 */
@customElement('idb-toggle-dashboard')
export class IdbToggleDashboard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  @property({ type: Boolean, attribute: 'show-more' })
  showMore: Boolean = false;

  protected firstUpdated(_changedProperties: PropertyValues): void {
    const container = this.shadowRoot?.querySelector(
      '.sections'
    ) as HTMLElement;

    Array.from(this.children).forEach(item => {
      // remove item from lightdom right away to avoid browser repainting while processing
      container.appendChild(item);
    });
  }

  updateToggle() {
    this.showMore = !this.showMore;

    const container = this.shadowRoot?.querySelector(
      '.sections'
    ) as HTMLElement;

    Array.from(container.children).forEach(item => {
      if (this.showMore) {
        item.setAttribute('show-more', `${this.showMore}`);
      } else {
        item.removeAttribute('show-more');
      }
    });
  }

  render(): TemplateResult {
    return html`
    <div class="test">
      <div class="toggle-container  show-${this.showMore ? 'more' : 'less'}">
        <span>Less</span>
        <div class="toggle" @click=${this.updateToggle}>
          <div class="circle"></div>
        </div>
        <span>More</span>
      </div>
      <div class="sections">
      </div>
    </div>
    `;
  }
}
